var map = {
	"./C-logo.png": 8698,
	"./CPP-logo.png": 5506,
	"./CSS3-logo.png": 9247,
	"./Git-Iogo.png": 4892,
	"./GitHub-logo.png": 808,
	"./Google-logo.png": 2400,
	"./JavaScript-logo.png": 9156,
	"./Python-logo.png": 9317,
	"./androd-logo.png": 1549,
	"./android-logo.jpeg": 4909,
	"./bootstrap-logo.png": 9745,
	"./canva-logo.jpeg": 8285,
	"./chat.png": 9793,
	"./cmrit-logo.png": 1168,
	"./express-logo.png": 4271,
	"./gamemate.png": 8238,
	"./home-logo.png": 832,
	"./html5-logo.png": 4875,
	"./java-logo.svg": 7235,
	"./jss-logo.jpeg": 4512,
	"./live.png": 9869,
	"./mongodb-logo.jpeg": 7642,
	"./mongodb-logo.png": 4741,
	"./mysql-logo.png": 9985,
	"./narayana-logo.png": 7132,
	"./nav.jpg": 9744,
	"./next-js.png": 898,
	"./nodejs-logo.svg": 4668,
	"./portfolio-logo.png": 6043,
	"./postman-logo.png": 9665,
	"./react-logo.png": 2264,
	"./simon-logo.png": 613,
	"./spotify-logo.png": 5301,
	"./street.png": 1278,
	"./tailwind-logo.png": 3739,
	"./techno.png": 6318,
	"./tictactoe-logo.png": 7431,
	"./transcendX.jpg": 7035,
	"./ved-logo.jpeg": 4873,
	"./viswabharathi-logo.jpg": 9746,
	"./vscode-logo.png": 3837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;